<script>
  import { theRoute } from "../store/shared"
  import { Navigate, Route, navigateTo } from 'svelte-router-spa';
  export let currentRoute;
  export let params;

  $: {
    theRoute.update(old => currentRoute);
  }

</script>

<Route {currentRoute} {params} />